import type { GetIndicatorResultAuditByIdResponseRow } from '@risksmart-app/trpc/types';
import type { GetIndicatorResultAuditByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetIndicatorResultAuditByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetIndicatorResultAuditByIdArgs = {
  id: string;
};

export const useGetIndicatorResultAuditById = createQueryHook<
  UseGetIndicatorResultAuditByIdArgs,
  GetIndicatorResultAuditByIdResponseRow[],
  GetIndicatorResultAuditByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.auditLog.getIndicatorResultAuditById.queryOptions({ id }),
  mapTrpcDataToGraphQL: (data) => ({ indicator_result_audit: data }),
  graphqlDocument: GetIndicatorResultAuditByIdDocument,
  graphqlVariables: ({ id }) => ({ id }),
});
